import { LevelObject } from "shared/levels";
import { Block } from "shared/model";

export class gameGameService {
    // public createStartMap(tilesContainer, substrateContainer) {
    //     for (let i = 0; i < LevelObject.columns; i++) {
    //         LevelObject.tiles[i] = [];
    //         for (let j = 0; j < LevelObject.rows; j++) {
    //             const sprite = this.createTile(i, j);
    //             const substrate = this.createSubstate(i,j);
    //             LevelObject.tiles[i].push(sprite);
    //             tilesContainer.addChild(sprite);
    //             substrateContainer.addChild(substrate);
    //             // AnimationUtil.createMoveTween(sprite);
    //         }
    //     }
    // }

    // public createTile(i, j): Block {
    //     const colors = DefaultConfig.colors;
    //     const color = colors[Math.floor(Math.random() * colors.length)];
    //     let sprite: Block;
    //     switch (color) {
    //         case 'red': {
    //             sprite = new Block(LoaderService.getResource('red').texture);
    //             sprite.color = 'red';
    //             sprite.type = 1;
    //             break;
    //         }
    //         case 'green': {
    //             sprite = new Block(LoaderService.getResource('pink').texture);
    //             sprite.color = 'green';
    //             sprite.type = 2;
    //             break;
    //         }
    //         case 'blue': {
    //             sprite = new Block(LoaderService.getResource('dark_purp').texture);
    //             sprite.color = 'blue';
    //             sprite.type = 3;
    //             break;
    //         }
    //         case 'brown': {
    //             sprite = new Block(LoaderService.getResource('purp').texture);
    //             sprite.color = 'brown';
    //             sprite.type = 4;
    //             break;
    //         }
    //         case 'yellow': {
    //             sprite = new Block(LoaderService.getResource('tile_5').texture);
    //             sprite.color = 'yellow';
    //             sprite.type = 5;
    //             break;
    //         }
    //     }
    //     const graphic = new PIXI.Graphics();
    //     graphic.beginFill();
    //     graphic.drawRect(0, 0, LevelObject.tileWidth, LevelObject.tileHeight);
    //     graphic.endFill();
    //     graphic.alpha = 0;
    //     const coord = this.getCoordinateTile(i, j);
    //     sprite.width = LevelObject.tileWidth - this.tilesMargin;
    //     sprite.height = LevelObject.tileHeight - this.tilesMargin;
    //     sprite.x = coord.tileX;
    //     sprite.y = coord.tileY;
    //     sprite.row = j;
    //     sprite.col = i;
    //     // sprite.stateMachine = new BlockStateMashine(sprite);
    //     sprite.shift = 0;
    //     sprite.addChild(graphic);
    //     return sprite;
    // }
}